import { createClient } from '@supabase/supabase-js'

// Aplikacija nema sopstveni server (1.1A, A6): jedini ključ koji stiže do preglednika je
// anon ključ, a sve što korisnik smije vidjeti odlučuje RLS nad njegovim JWT-om.
const url = import.meta.env.VITE_SUPABASE_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anon) {
  throw new Error(
    'Nedostaje VITE_SUPABASE_URL ili VITE_SUPABASE_ANON_KEY. ' +
      'Kopiraj app/.env.example u app/.env.local (vidi docs/okruzenja.md).',
  )
}

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Prijava je lozinkom postavljenom kroz pozivnicu (C25); nema linkova u URL-u.
    detectSessionInUrl: false,
  },
})

/** Adresa projekta na koji je ovaj build vezan — piše u podnožju, da se test i produkcija
 *  ne pomiješaju u pregledniku (docs/okruzenja.md). */
export const adresaProjekta = url
